import React from 'react';
import {auth, logout} from '../../firebase/firebase'
// import { signOut } from 'firebase/auth' 
// import {Activity,ActivityString, currentRequestTimeStamp} from '../../../Constants'
import './NoAccess.css';
// import { Redirect } from 'react-router';

const NoAccess = () => {
  const noAccessMessage =
    "Your request to access LoRRI has been submitted to our team and we will get back to you shortly. Should you need any assistance or have a question in the mean time, please email (associate@logisticsnow.in) or call +91-9867773508 / +91-9653620207";
    const Logmeout = () => {
      // localStorage.removeItem("accessToken")
      sessionStorage.removeItem("accessToken")
      localStorage.removeItem("user_name")
      logout(auth);
      window.location.reload();
    };
  return (
    <div className="no-access-container">
      <div style={{float:"right"}} className="row">
        
        <button onClick={(e)=>Logmeout(e)} className="btn btn-sm btn-primary"><i className="fa fa-times"></i></button>

      </div>
      <div style={{marginTop:"5%"}} className="row">
      <span className="s-nm">{noAccessMessage}</span>
      </div>
      <div style={{marginTop:"3%"}} className="row">
        
        <button style={{marginLeft:"50%"}} onClick={(e)=>Logmeout(e)} className="btn btn-sm btn-primary s-try">Try Again</button>

       
      </div>
    </div>
  );
};

export default NoAccess;
